import { FC, JSX } from 'react';

import { Button, ButtonProps, Flex, Modal, ModalProps } from 'antd';
import classNames from 'classnames';

import styles from './ConfirmationModal.module.scss';

type TConfirmationModalProps = ModalProps & {
	cancelButtonProps?: ButtonProps;
	submitButtonProps?: ButtonProps;
};

export const ConfirmationModal: FC<TConfirmationModalProps> = ({
	open,
	onClose,
	children,
	cancelButtonProps,
	submitButtonProps,
	...restProps
}): JSX.Element => {
	return (
		<Modal
			closeIcon={null}
			footer={
				<Flex align="center" className={styles['buttons']} gap={16} justify="center">
					<Button
						className={classNames(styles['button'], styles['cancel-button'])}
						type="default"
						variant="outlined"
						{...cancelButtonProps}
					/>
					<Button
						className={classNames(styles['button'], styles['submit-button'])}
						type="primary"
						{...submitButtonProps}
					/>
				</Flex>
			}
			open={open}
			onCancel={onClose}
			{...restProps}
		>
			<div className={styles['content']}>{children}</div>
		</Modal>
	);
};
